import { postRequest } from '../../../shared/utils';

export async function validateSheet1HtzService(htz: string, screenGridId: number) {
  const body = {
    columns: ['htz'],
    screenGridId,
    schema: 'npi',
    table: 'sheet1',
    key: 'htz',
    value: htz,
  };
  const { data, errors } = await postRequest('/api/records', body);
  if (errors) {
    console.error(errors);
    return null;
  }

  if (data) {
    const { npi_sheet1: sheet1HtzData } = data;
    return sheet1HtzData && sheet1HtzData.length > 0 ? sheet1HtzData[0].htz : null;
  }

  return null;
}
